import React, { useState, useEffect, useRef } from "react";
import { useAppSelector } from "../../redux/typedHooks";
import type { UserInterface } from "../../types/user";
import CreateFirstPostModal from "./CreateFirstPostModal";
import { getUserType } from "../../utils/getUserType";

const CreateFirstPostModalManager: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const hasCheckedRef = useRef(false);
  const user = useAppSelector<UserInterface | null>(
    state => state.user.currentUser
  );

  // Don't show modal on onboarding screen or if user hasn't completed onboarding
  // Use window.location.pathname since component is rendered outside Router
  const isOnboardingPage = typeof window !== "undefined" && window.location.pathname === "/choose-user-type";
  const hasCompletedOnboarding = user?.isOnboarding === true;
  
  // Check if user is creator (model) - modal should only show for creators
  const userType = getUserType(user);
  const userTypeTitle = userType?.title?.toLowerCase();
  const isCreator = userTypeTitle === "creator" || userTypeTitle === "model" || userType?._id === "6800a63485ec077c7c266c25";

  useEffect(() => {
    // Don't show modal on onboarding page, if user hasn't completed onboarding, or if user is not a creator
    if (isOnboardingPage || !hasCompletedOnboarding || !isCreator) {
      setShowModal(false);
      return;
    }

    // Check if user is logged in and has isModalCreateFirstPost flag
    if (user && !hasCheckedRef.current) {
      hasCheckedRef.current = true;
      // Check if user has isModalCreateFirstPost flag set to true
      const isModalCreateFirstPost = (user as any)?.isModalCreateFirstPost;
      if (isModalCreateFirstPost === true) {
        setShowModal(true);
      }
    } else if (!user) {
      hasCheckedRef.current = false;
      setShowModal(false);
    }
  }, [user, isOnboardingPage, hasCompletedOnboarding, isCreator]);

  // Also check when user data updates (e.g., after fetching personal info)
  const isModalCreateFirstPost = (user as any)?.isModalCreateFirstPost;
  useEffect(() => {
    // Don't show modal on onboarding page, if user hasn't completed onboarding, or if user is not a creator
    if (isOnboardingPage || !hasCompletedOnboarding || !isCreator) {
      setShowModal(false);
      return;
    }

    if (user) {
      if (isModalCreateFirstPost === true && !hasCheckedRef.current) {
        hasCheckedRef.current = true;
        setShowModal(true);
      } else if (isModalCreateFirstPost === false) {
        setShowModal(false);
      }
    }
  }, [user, user?.id, isModalCreateFirstPost, isOnboardingPage, hasCompletedOnboarding, isCreator]);

  const handleClose = () => {
    setShowModal(false);
  };

  return <CreateFirstPostModal open={showModal} onClose={handleClose} />;
};

export default CreateFirstPostModalManager;

